// extracted by mini-css-extract-plugin
export default {"label":"VtKzMON2ltzR5Uc91S_U","saving":"eY_IVkc2x_Gu_ACd5ElJ","label-and-tooltip":"EeSEcRH46Sf0bN_oiVhR"};